import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { message } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SoftButton from "StyleFeatures/SoftButton";
import SoftTypography from "StyleFeatures/SoftTypography";
import SoftInput from "StyleFeatures/SoftInput";
import SoftBox from "StyleFeatures/SoftBox";
import { ToastContainer } from "react-toastify";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";

const CandidateForgotPasswrod = () => {
    const [ email, setEmail ] = useState("");
    const [ emailError, setEmailError ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEmailError(null);

         if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError("Valid email required");
      return;
    }
    try{
          setLoading(true);
          const response = await axiosInstance.post(API.candidate.forgot,{
            email:email
          })

          const data = response.data;
          if( data?.success !== false){
            message.success ("Your Request Submitted Successfully");
            setTimeout(() => {
                navigate("/candidate-forgot-chekemail")
            }, 2000);
            setEmail("");
          }
    } catch (error){
        console.error("Error in Email Submitting " , error);
         const msg = error.response?.data?.details ;
              message.error(msg);
    } finally{
        setLoading(false);
    }
    }
    return(
           <CoverLayout
      title="Forgot Password"
      description="Enter your email to receive reset link"
      image={curved9}
    >
      <SoftBox component="form" onSubmit={handleSubmit}>
        <ToastContainer position="top-left" />

        {/* Email */}
        <SoftBox mb={2}>
          <SoftTypography variant="caption" fontWeight="bold">
            Email
          </SoftTypography>

          <SoftInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(null);
            }}
            className={`form-control ${emailError ? "is-invalid" : ""}`}
          />

          {emailError && (
            <SoftTypography color="error" variant="caption">
              {emailError}
            </SoftTypography>
          )}
        </SoftBox>

        {/* Submit */}
        <SoftButton type="submit" fullWidth variant="gradient" color="info">
          {loading ? "Sending..." : "Send Reset Link"}
          {loading && (
            <span className="spinner-border spinner-border-sm" style={{ marginLeft: "8px" }} />
          )}
        </SoftButton>
      </SoftBox>
    </CoverLayout>
    )
}

export default CandidateForgotPasswrod;